import { useState } from 'react';
import { usePopper } from 'react-popper';

const usePopper2 = ({ options = {} } = {}) => {
  const [referenceElementRef, setReferenceElementRef] = useState(null);
  const [popperElementRef, setPopperElementRef] = useState(null);
  const [arrowElementRef, setArrowElementRef] = useState(null);
  const popper = usePopper(referenceElementRef, popperElementRef, {
    ...options,
    modifiers: [
      { name: 'arrow', options: { element: arrowElementRef } },
      ...(options?.modifiers ?? []),
    ],
  });
  return [
    setReferenceElementRef,
    setPopperElementRef,
    setArrowElementRef,
    popper,
  ];
};

export default usePopper2;
